<!-- Spinner -->
<div class="gray-background" [style.display]="saving ? 'flex' : 'none'" [style.z-index]="1002"></div>
<div class="save-spinner" [style.display]="saving ? 'flex' : 'none'"><i class="fa fa-circle-o-notch fa-spin" style="font-size:24px"></i></div>
